/*eslint-disable*/
import React, { useState, useEffect } from 'react';
import { Dropdown, Input, Icon } from 'semantic-ui-react'
import APP_CONSTANTS from '../../config/constants';
import AddSerialNoModal from '../jobcardComponent/jobcardTypeComponent/addSerialNoModal';
import Axios from 'axios';
import {getBatteryDetails} from '../mastersComponent/batteryInventory/batteryActions'
import {getTyreDetails} from '../mastersComponent/tyreInventory/tyreActions'
import cogoToast from 'cogo-toast';

const JobcardSerialNo = ({
  field: { name, value },
  form: { touched, errors, setFieldValue },
  ...props
}) => {
  const errorText = touched[name] && errors[name];

  const [serialNumbers, setserialNumbers] = useState([])
  const [isloading, setisloading] = useState(false)
  const [openNewSerialNoModal, setOpenNewSerialNoModal] = useState(false)

  useEffect(() => {

    if ((props?.typeOfActivity == 1 || props?.typeOfActivity == 4) && props?.addNewSerialNoPassed?.length > 0 && props?.oldMapIdPassed) {
      setFieldValue(name, { productInventoryId: props.oldMapIdPassed, serialNo: props.addNewSerialNoPassed })
    }

    setisloading(true)
    let token = localStorage.getItem('apiToken')
    let userId = localStorage.getItem('userId')
    let customerNo = localStorage.getItem('customerNo')
    let data = JSON.stringify
      ({
        api_token: token,
        customerNo: customerNo,
        isTyreProduct: props.TyreId,
        searchString: '',
        isAvailable: 1,
        userId: userId
      })
    // console.log(APP_CONSTANTS)
    Axios.post(`${APP_CONSTANTS.BASE_URL}fleet/jobcard/getInventoryWithoutJobcard`, data, {
      headers: {
        'Content-Type': 'application/json',
        "Authorization": localStorage.getItem('apiToken'),
        "Access-Control-Allow-Origin": "*"
      }
    }).then((response => {
      setisloading(false)
      setserialNumbers(response.data.data)
    }))
      .catch(error => console.log(error))
  }, [props?.typeOfActivity, props?.addNewSerialNoPassed, props?.oldMapIdPassed])



  let srNums = []
  if (serialNumbers.length > 0) {
    serialNumbers.map((object, index) => {
      let temp = {}
      temp.key = object?.serialNo?.toLowerCase()
      temp.text = object?.serialNo
      temp.value = { productInventoryId: object.productInventoryId, serialNo: object.serialNo }
      return srNums[index] = temp
    })
  }

  const openNewSerialNoModalClose = (e) => {
    if (e != null || e != undefined) {
      e.stopPropagation();
      setOpenNewSerialNoModal(false)
    }
  }
  const validateBatterySerialNo = async (serialNo)=>{
    if(serialNo){
      let battery_master = await getBatteryDetails(serialNo)
      let validation_response
      if(battery_master?.resultSet?.length > 0){
        validation_response = {
          error : true ,
          error_msg  : `Battery already exists with serial number ${serialNo}`,
          resultSet : battery_master?.resultSet
        } 
      }else{
        validation_response = {
          error : false ,
          error_msg  : "",
          resulSet: []
        }
      }
      return validation_response
    }
  }

  const validateTyreSerialNo = async (serialNo)=>{
    if(serialNo){
      let tyre_master = await getTyreDetails(serialNo)
      let validation_response
      if(tyre_master?.resultSet?.length > 0){
        validation_response = {
          error : true ,
          error_msg  : `Tyre already exists with serial number ${serialNo}`,
          resultSet : tyre_master?.resultSet
        } 
      }else{
        validation_response = {
          error : false ,
          error_msg  : "",
          resulSet: []
        }
      }
      return validation_response
    }
  }

  const addSerialNoToList = async (data) => {
    let validation_response
    if(data && props.type === "battery"){
      validation_response = await validateBatterySerialNo(data)
    }else if(data && props.type==="tyre"){
      validation_response = await validateTyreSerialNo(data)
    }
    if(validation_response && validation_response.error){
      cogoToast.error(validation_response.error_msg)
      return;
    }
    let temp = { productInventoryId: 0, serialNo: data }
    let tempAddToList = {
      key: data.toLowerCase(),
      text: data,
      value: { serialNo: data }
    }

    let tempAddToListSr = {
      customerNo: localStorage.getItem('customerNo'),
      productInventoryId: 0,
      serialNo: data
    }

    let addToList = false;

    srNums.forEach(element => {
      if (element.text == data) {
        addToList = true;
        setFieldValue(name, element.value)
      }
    });

    if (!addToList) {
      srNums.push(tempAddToList)

      let list = serialNumbers;
      list.push(tempAddToListSr)
      setserialNumbers(list)

      setFieldValue(name, temp)
    }

    if (props?.setFlag) {
      setFieldValue(props.setFlag, 1)
    }

    setOpenNewSerialNoModal(false)
  }

  return (
    <>
      <Dropdown
        selection
        search
        clearable
        style={{ width: '100%' }}
        className='placeholder-black darkplaceholder'
        loading={isloading}
        onChange={(value, data) => {
          setFieldValue(name, data.value)
          if (props?.setFlag) {
            setFieldValue(props.setFlag, 1)
          }
        }}
        error={errorText}
        id="searchType"
        options={srNums}
        {...props}
      />
      {props?.showAddSrno ?
        <>
          <Icon name='add' onClick={(e) => { e.stopPropagation(); setOpenNewSerialNoModal(true) }} />
          {openNewSerialNoModal ?
            <AddSerialNoModal setmodalOpen={openNewSerialNoModalClose} modalOpen={openNewSerialNoModal} addSerialNoToList={addSerialNoToList} />
            : null}
        </>
        : null}
    </>
  )
}

export default JobcardSerialNo